<div class="upsell-sticky-bar bg-white py-2.5 px-1.5">
  <div class="upsell-sticky-bar__container">
    <div class="upsell-sticky-bar_upgrade-downgrade-buttons" *ngIf="showButton">
      <upsell-guarantee 
        [buttonYesText]="buttonYesText"
        [showbuttonYesText]="showbuttonYesText" [buttonNoText]="buttonNoText"
        [showbuttonNoText]="showbuttonNoText" [description]="description"
        [showDescription]="showDescription" [image]="image"
        [imageAlt]="imageAlt" [showImage]="showImage" [upsellCtaTextButtonsClass]="upsellCtaTextButtonsClass"
        (eventEmitter)="nextPage($event)">
      </upsell-guarantee>
    </div>
  </div>
</div>